import React from "react";


function AddContractForm({
  formData,
  onInputChange,
  onSelectChange,
  submittedForm,
  readOnly,
  mode,
  onDocumentsChange,
  newDocuments,
  existingDocuments,
}) {

  return (
    <form>
      <div
        className="form-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "20px",
        }}
      >
        {/* Contract Name */}
        <div className="mb-3">
          <label className="form-label required">Contract Name</label>
          <input
            type="text"
            name="contract_name"
            className="form-control form-control-solid"
            placeholder={
              submittedForm
                ? formData.contract_name
                : "Enter Contract Name"
            }
            value={submittedForm ? "" : formData.contract_name}
            onChange={onInputChange}
            disabled={submittedForm || readOnly}
          />
        </div>

        {/* Contract Type */}
        <div className="mb-3">
          <label className="form-label required">Contract Type</label>

          <select
            className="form-select form-select-solid"
            value={formData.contract_type}
            onChange={(e) => {
              const value = e.target.value;

              onSelectChange("contract_type", value);

              if (["trial", "poc"].includes(value)) {
                onSelectChange("duration_unit", "Days");
              }
            }}
            disabled={submittedForm || readOnly}
          >
            <option value="">Select Type</option>
            <option value="trial">Trial</option>
            <option value="poc">POC</option>
            <option value="enterprise">Enterprise</option>
            {/* <option value="Support">Support</option>
            <option value="License">License</option>
            <option value="Implementation">Implementation</option> */}
          </select>

        </div>

        {/* Status */}
        <div className="mb-3">
          <label className="form-label required">Status</label>

          <select
            name="status"
            className="form-select form-select-solid"
            value={formData.status}
            onChange={(e) => onSelectChange("status", e.target.value)}
            disabled={submittedForm || readOnly}
          >
            <option value="Draft">Draft</option>
            <option value="Active">Active</option>
            <option value="Expired">Expired</option>
            <option value="Cancelled">Cancelled</option>
          </select>
        </div>

        {/* Start Date */}
        <div className="mb-3">
          <label className="form-label required">Start Date</label>

          <input
            type={submittedForm ? "text" : "date"}
            name="start_date"
            className="form-control form-control-solid"
            value={submittedForm ? "" : formData.start_date}
            placeholder={submittedForm ? formData.start_date : ""}
            onChange={onInputChange}
            disabled={submittedForm || readOnly}
          />
        </div>

        {/* Duration */}
        <div className="mb-3">
          <label className="form-label required">Duration</label>

          <input
            type="number"
            min={1}
            name="duration_value"
            className="form-control form-control-solid"
            placeholder={
              submittedForm
                ? String(formData.duration_value)
                : "Enter Duration"
            }
            value={submittedForm ? "" : formData.duration_value}
            onChange={onInputChange}
            disabled={submittedForm || readOnly}
          />
        </div>

        {/* Duration Unit */}
        <div className="mb-3">
          <label className="form-label required">Duration Unit</label>

          <select
            className="form-select form-select-solid"
            value={formData.duration_unit}
            onChange={(e) =>
              onSelectChange("duration_unit", e.target.value)
            }
            disabled={submittedForm || readOnly}
          >
            <option value="">Select Unit</option>
            <option value="Days">Days</option>
            <option value="Months">Months</option>
          </select>
        </div>

        {/* Contract Value */}
        <div className="mb-3">
          <label className="form-label required">Contract Value</label>

          <input
            type="number"
            name="contract_value"
            className="form-control form-control-solid"
            placeholder={
              submittedForm
                ? String(formData.contract_value)
                : "Enter Contract Value"
            }
            value={submittedForm ? "" : formData.contract_value}
            onChange={onInputChange}
            disabled={submittedForm || readOnly}
          />
        </div>

        {/* Currency */}
        <div className="mb-3">
          <label className="form-label">Currency</label>
          <select
            className="form-select form-select-solid"
            value={formData.currency}
            onChange={(e) => onSelectChange("currency", e.target.value)}
            disabled={submittedForm || readOnly}
          >
            <option value="INR">INR</option>
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
          </select>

        </div>

        {/* Billing Cycle */}
        <div className="mb-3">
          <label className="form-label required">Billing Cycle</label>

          <select
            className="form-select form-select-solid"
            value={formData.billing_cycle}
            onChange={(e) =>
              onSelectChange("billing_cycle", e.target.value)
            }
            disabled={submittedForm || readOnly}
          >
            <option value="">Select Billing Cycle</option>
            <option value="Monthly">Monthly</option>
            <option value="Quarterly">Quarterly</option>
            <option value="Yearly">Yearly</option>
          </select>

        </div>



        {/* Support Plan */}
        {/* <div className="mb-3">
          <label className="form-label">Support Plan</label>

          {submittedForm ? (
            <input
              className="form-control form-control-solid"
              placeholder={formData.support_plan}
              disabled
            />
          ) : (
            <select
              className="form-select form-select-solid"
              value={formData.support_plan}
              onChange={(e) =>
                onSelectChange("support_plan", e.target.value)
              }
            >
              <option value="">Select Plan</option>
              <option value="Basic">Basic</option>
              <option value="Standard">Standard</option>
              <option value="Premium">Premium</option>
            </select>
          )}
        </div> */}

        {/* Auto Renew */}
        {/* <div className="mb-3">
          <label className="form-label">Auto Renew</label>

          {submittedForm ? (
            <input
              className="form-control form-control-solid"
              placeholder={formData.auto_renew ? "Yes" : "No"}
              disabled
            />
          ) : (
            <select
              className="form-select form-select-solid"
              value={String(formData.auto_renew)}
              onChange={(e) =>
                onSelectChange("auto_renew", e.target.value === "true")
              }
            >
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          )}
        </div> */}

        {/* Signed Date */}
        <div className="mb-3">
          <label className="form-label">Signed Date</label>

          <input
            type={submittedForm ? "text" : "date"}
            name="signed_date"
            className="form-control form-control-solid"
            value={submittedForm ? "" : formData.signed_date}
            placeholder={submittedForm ? formData.signed_date : ""}
            onChange={onInputChange}
            disabled={submittedForm || readOnly}
          />
        </div>

        {/* Documents */}
        <div
          className="mb-3"
          style={{ gridColumn: "1 / span 2" }}
        >
          <label className="form-label">Documents</label>

          {!readOnly && (
            <input
              type="file"
              className="form-control form-control-solid"
              multiple
              accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.png,.jpg,.jpeg"
              onChange={(e) =>
                onDocumentsChange(
                  Array.from(e.target.files || [])
                )
              }
            />
          )}

          {/* Existing documents */}
          {existingDocuments.length > 0 && (
            <>
              <h6 className="mt-3">Uploaded Documents</h6>

              {existingDocuments.map((doc) => (
                <div
                  key={doc.id}
                  className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
                >
                  <div>
                    <div className="fw-semibold">
                      {doc.original_file_name}
                    </div>

                    <small className="text-muted">
                      {(doc.file_size / 1024).toFixed(1)} KB
                    </small>
                  </div>

                  <a
                    href={doc.s3_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-light-primary"
                  >
                    View
                  </a>
                </div>
              ))}
            </>
          )}

          {/* Newly selected files */}
          {newDocuments.length > 0 && (
            <>
              <h6 className="mt-3">New Documents</h6>

              {newDocuments.map((file, index) => (
                <div
                  key={index}
                  className="border rounded p-2 mb-2"
                >
                  <div className="fw-semibold">
                    {file.name}
                  </div>

                  <small className="text-muted">
                    {(file.size / 1024).toFixed(1)} KB
                  </small>
                </div>
              ))}
            </>
          )}
        </div>
        {/* Remarks */}
        <div
          className="mb-3"
          style={{ gridColumn: "1 / span 2" }}
        >
          <label className="form-label">Remarks</label>

          <textarea
            rows={4}
            name="remarks"
            className="form-control form-control-solid"
            placeholder={
              submittedForm
                ? formData.remarks
                : "Enter Remarks"
            }
            value={submittedForm ? "" : formData.remarks}
            onChange={onInputChange}
            disabled={submittedForm || readOnly}
          />
        </div>
      </div>

      {/* {mode !== "view" && (
        <button
          className="btn"
          style={{
            backgroundColor: "#6D9300",
            color: "white",
          }}
          onClick={handleSubmit}
        >
          {mode === "add"
            ? "Create Contract"
            : "Update Contract"}
        </button>
      )} */}
    </form>
  );
}

export default AddContractForm;